async function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

class TerminalText extends HTMLElement {
  text = '';
  isAnimating = false;

  constructor() {
    super();

    this.text = this.innerText;
    this.addEventListener('mouseover', this.onHover.bind(this));
  }

  async onHover(e) {
    this.animate();
  }

  async animate() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    this.style.width = this.clientWidth + 'px';
    let textToPlace = this.text;
    let currentText = '';
    this.innerText = '_';
    await sleep(Math.random() * 10 + 20);
    while (textToPlace.length > 0) {
      currentText += textToPlace.substring(0, 1);
      this.innerText = currentText + '_';
      await sleep(Math.random() * 10 + 20);
      textToPlace = textToPlace.substring(1);
    }
    this.innerText = this.text;

    this.isAnimating = false;
    this.style.width = 'auto';
  }
}

customElements.define('terminal-text-element', TerminalText);
